/**
 * Priority level colors
 * Fixed colors for priority column (cannot be customized)
 */

export const PRIORITY_COLORS = {
  critical: '#e2445c', // Red
  high: '#fdab3d', // Orange
  medium: '#ffcb00', // Yellow
  low: '#579bfc', // Blue
  none: '#c4c4c4', // Gray
} as const;

export type PriorityColor = (typeof PRIORITY_COLORS)[keyof typeof PRIORITY_COLORS];

/**
 * Priority level metadata
 */
export const PRIORITY_LEVELS = [
  { id: 'critical', label: 'Critical', color: PRIORITY_COLORS.critical, value: 5 },
  { id: 'high', label: 'High', color: PRIORITY_COLORS.high, value: 4 },
  { id: 'medium', label: 'Medium', color: PRIORITY_COLORS.medium, value: 3 },
  { id: 'low', label: 'Low', color: PRIORITY_COLORS.low, value: 2 },
  { id: 'none', label: 'None', color: PRIORITY_COLORS.none, value: 1 },
] as const;

export type PriorityLevelId = (typeof PRIORITY_LEVELS)[number]['id'];
